module.exports = __webpack_public_path__ + "static/faunaflora-midway-e7bd84e72c98b427428bd1c6279f8fb0.jpg";